import { render, staticRenderFns } from "./AllAttributeForms.vue?vue&type=template&id=ac194b2e&scoped=true&"
import script from "./AllAttributeForms.vue?vue&type=script&lang=js&"
export * from "./AllAttributeForms.vue?vue&type=script&lang=js&"
import style0 from "./AllAttributeForms.vue?vue&type=style&index=0&id=ac194b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac194b2e",
  null
  
)

export default component.exports